import { SAMPLE_POSTS } from "@/shared/content.js";
import { formatDate } from "@/shared/format.js";
import { uz } from "@/shared/i18n/uz.js";
import { Container, SampleNotice, SectionTitle } from "@/shared/ui/index.js";
import { usePageMeta } from "@/app/meta.js";
import { Link } from "@/app/router.js";

export function PostsPage() {
  usePageMeta(uz.posts.title, uz.posts.lead);

  return (
    <Container className="py-12">
      <SectionTitle title={uz.posts.title} lead={uz.posts.lead} />
      <SampleNotice text={uz.sample.notice} />

      {SAMPLE_POSTS.length === 0 ? (
        <p className="text-ink-2 py-10 text-center">{uz.posts.empty}</p>
      ) : (
        <ul className="divide-line border-line divide-y border-y">
          {SAMPLE_POSTS.map((post) => (
            <li key={post.slug}>
              <Link
                to={{ name: "post", slug: post.slug }}
                className="hover:bg-card -mx-3 flex flex-col gap-1 rounded-lg px-3 py-5 transition"
              >
                <span className="text-ink-3 flex items-center gap-2 text-xs">
                  <span className="text-gold font-medium">{post.tag}</span>
                  <span>{formatDate(post.date)}</span>
                </span>
                <h2 className="text-xl leading-snug font-semibold">{post.title}</h2>
                <p className="text-ink-2 max-w-[70ch]">{post.excerpt}</p>
              </Link>
            </li>
          ))}
        </ul>
      )}
    </Container>
  );
}

/** Bitta e'lon. Topilmasa — ro'yxatga qaytaramiz, "404" ko'rsatmaymiz. */
export function PostPage({ slug }: { slug: string }) {
  const post = SAMPLE_POSTS.find((item) => item.slug === slug);
  usePageMeta(post?.title ?? uz.posts.title, post?.excerpt);

  if (!post) {
    return (
      <Container className="py-16">
        <p className="text-ink-2">{uz.posts.empty}</p>
        <Link to={{ name: "posts" }} className="text-gold mt-4 inline-block font-medium">
          {uz.posts.back}
        </Link>
      </Container>
    );
  }

  return (
    <Container className="py-12">
      <Link to={{ name: "posts" }} className="text-ink-3 hover:text-ink text-sm">
        {uz.posts.back}
      </Link>

      <article className="mt-6 max-w-[68ch]">
        <p className="text-ink-3 flex items-center gap-2 text-sm">
          <span className="text-gold font-medium">{post.tag}</span>
          <span>{formatDate(post.date)}</span>
        </p>

        <h1 className="font-cond mt-2 text-4xl leading-tight font-bold tracking-tight">
          {post.title}
        </h1>

        <div className="mt-6 flex flex-col gap-4 text-lg">
          {post.body.map((paragraph) => (
            <p key={paragraph}>{paragraph}</p>
          ))}
        </div>
      </article>
    </Container>
  );
}
